module.exports = __webpack_public_path__ + "img/comment-support-icon.9fb00508.svg";